import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { ObjectCardExpandedState } from '@common/components/object-card';

/** По умолчанию все блоки карточки раскрыты */
function createObjectCardExpandedState(): ObjectCardExpandedState {
  return {
    general: true,
    drivers: true,
    trailers: true,
    geozones: true,
    sensors: true,
    params: true,
    connectionSettings: true,
    customFields: true,
    specifications: true,
    maintenance: true,
  };
}

@Injectable({
  providedIn: 'root',
})
export class AppService {
  public isLoading = new BehaviorSubject(false);

  /** Состояние аккордеонов всплывающей карточки — общее для всех попапов */
  stateObjectCardSettings: ObjectCardExpandedState = createObjectCardExpandedState();

  /**
   * Состояние аккордеонов фиксированных карточек — своё у каждой.
   * Живёт, пока карточка открыта, в том числе при уходе со страницы мониторинга.
   */
  private readonly fixedObjectCardExpandedState = new Map<number, ObjectCardExpandedState>();

  getFixedObjectCardExpandedState(objectId: number): ObjectCardExpandedState {
    let state = this.fixedObjectCardExpandedState.get(objectId);

    if (!state) {
      state = createObjectCardExpandedState();
      this.fixedObjectCardExpandedState.set(objectId, state);
    }

    return state;
  }

  resetFixedObjectCardExpandedState(objectId: number): void {
    this.fixedObjectCardExpandedState.delete(objectId);
  }
}
